/**
 * Jargon — inline term wrapped in a click/hover popover.
 *
 * Used inside the Delivery Playbooks screen to explain technical language
 * in plain English for non-technical operators. The trigger looks like a
 * subtle underlined pill; on click or hover it reveals a "what it is" +
 * "how to explain it to a client" tooltip.
 */
import { Popover, PopoverContent, PopoverTrigger } from '../components/ui/popover';

export function Jargon({ term, children }) {
  if (!term) return children;
  const { label, plain, tip } = term;
  return (
    <Popover>
      <PopoverTrigger
        asChild
        data-testid={`jargon-trigger-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <button
          type="button"
          className="underline decoration-dotted decoration-neutral-400 underline-offset-[3px] text-neutral-900 hover:decoration-neutral-900 hover:text-black transition-colors cursor-help"
        >
          {children}
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        className="w-[340px] bg-white text-neutral-900 ring-1 ring-neutral-200 shadow-xl rounded-lg p-4"
        data-testid={`jargon-popover-${label.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-neutral-500 mb-1.5">
          Plain English
        </div>
        <div className="text-[15px] font-semibold text-neutral-900 mb-2">{label}</div>
        <p className="text-[13px] leading-relaxed text-neutral-700">{plain}</p>
        <div className="mt-3 pt-3 border-t border-neutral-100">
          <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-neutral-500 mb-1.5">
            If a client asks
          </div>
          <p className="text-[13px] leading-relaxed text-neutral-800 italic">{tip}</p>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default Jargon;
